import * as types from "./types";

export const consultarKeyCaptcha = () => ({
  type: types.CONSULTAR_KEY_CAPTCHA
});

export const keyCaptchaConsultada = (payload) => ({
  key: payload,
  type: types.KEY_CAPTCHA_CONSULTADA
});

export const errorConsultandoKeyCaptcha = (error) => ({
  type: types.ERROR_CONSULTANDO_KEY_CAPTCHA,
  error: error
});

export const limpiarEstadoSeguridad = () => ({
  type: types.LIMPIAR_STATE_SEGURIDAD
});
